// @flow

import React, { type Element, useState } from 'react'
import { Container, Grid } from '@material-ui/core'
import { MuiThemeProvider } from '@material-ui/core/styles'
import BCPEnrollmentCheckbox from '../BCPEnrollmentCheckbox'
import type { PrivateFacility as Facility } from '../types'
import theme from '../../../theme'
import AlertError from '../../Common/AlertError'
import { UserContext, UserContextProps } from '../../Common/UserContext'
import PrivateFacility from '../PrivateFacility'

type Props = {|
  userId: string,
  role: string,
  isBcpEnrolled: boolean,
  createdFacilities: Array<Facility>,
  serverErrors?: { [string]: Array<string> },
  bcpEnabled: boolean,
|}

function AccountSettingsContainer({
  userId,
  role,
  isBcpEnrolled,
  createdFacilities,
  serverErrors,
  bcpEnabled,
}: Props): Element<typeof MuiThemeProvider> {
  const [errors, setErrors] = useState(serverErrors)
  const [isBCPEnrolled, setIsBCPEnrolled] = useState(isBcpEnrolled)
  const userContextProps = new UserContextProps(userId, role)

  function handleServerErrors(errors: { [string]: Array<string> }): void {
    setErrors(errors)
  }

  return (
    <MuiThemeProvider theme={theme}>
      {bcpEnabled && (
        <UserContext.Provider value={userContextProps}>
          <Container maxWidth="md" disableGutters>
            <Grid item xs={12}>
              {errors && <AlertError errors={errors} />}
            </Grid>
            <BCPEnrollmentCheckbox
              checked={isBCPEnrolled}
              setChecked={setIsBCPEnrolled}
              handleServerErrors={handleServerErrors}
            />
            {isBCPEnrolled && (
              <PrivateFacility
                handleServerErrors={handleServerErrors}
                createdFacilities={createdFacilities}
              />
            )}
          </Container>
        </UserContext.Provider>
      )}
    </MuiThemeProvider>
  )
}

export default AccountSettingsContainer
